import React from "react"
import Embedded from "./embedded"
import Photo from "./photo"
import Video from "./video"
import PhotoGallery from "./photoGallery"

const PlaceElement = (props) => {
  let renderedObject
  if (props.object.type === 'Embedded' || props.object.type === 'embedded') {
    renderedObject = <Embedded object={props.object}/>
  } else if ( props.object.type === 'photo' || props.object.type === 'Photo'){
    renderedObject = <Photo object={props.object} photoName="JDX-NO-RATIO" photoSizes={props.sizes}/>

  } else if ( props.object.type === 'PhotoGallery' || props.object.type === 'photoGallery'){
    renderedObject = <PhotoGallery object={props.object}/>
  } else if ( props.object.type === 'Video' || props.object.type === 'video'){
    renderedObject = <Video object={props.object}/>
  } else {
    renderedObject = <div>Element type: {props.object.type}, JSON: {JSON.stringify(props.object)}</div>
  }


  return (
    <div>
      {renderedObject}
    </div>
  )
}

export default PlaceElement


